import { render, staticRenderFns } from "./MultiInstancesResourceView.vue?vue&type=template&id=8959129e&"
import script from "./MultiInstancesResourceView.vue?vue&type=script&lang=js&"
export * from "./MultiInstancesResourceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports